export function mergeOrder<T>(
  stored: readonly T[] | undefined,
  defaults: readonly T[],
): T[] {
  return Array.from(new Set([...(stored ?? []), ...defaults]));
}
